<div class="appContentsContainer">
  <form
    [formGroup]="solicitudDatos"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm"
  >
    <div class="pageTitle">Seleccione el tipo de solicitud</div>
    <div class="lineGradient"></div>
    <div class="wrapper">
      <div class="firstPart">
        <label for="Individual" id="Individual"> Individual </label>
      </div>
      <div class="secondPart">
        <span>
          <input
            id="peticionType"
            type="radio"
            value="individual"
            name="peticionType"
            style="cursor: pointer !important"
            (change)="changePeticionType($event)"
            checked
          />
        </span>
        <div class="extraTextContainer">
          <div class="extraText">
            <em
              class="fas fa-info-circle"
              data-toggle="tooltip"
              data-placement="top"
              title="Un único bastidor"
            ></em>
          </div>
        </div>
      </div>
      <ng-container
        *appPermsRoles="[
          roles.ADMIN,
          roles.ANALISTA,
          roles.AAVANZA,
          roles.ABASICO,
          roles.REVISOR,
          roles.RHOMOLOG
        ]"
      >
        <div class="firstPart">
          <label class="inputLabel" for="peticionType"
            >Masiva homologador</label
          >
        </div>
        <div class="secondPart">
          <span>
            <input
              id="peticionType"
              type="radio"
              value="homologar"
              name="peticionType"
              style="cursor: pointer !important"
              (change)="changePeticionType($event)"
            />
          </span>
          <div class="extraTextContainer">
            <div class="extraText">
              <em
                class="fas fa-info-circle"
                data-toggle="tooltip"
                data-placement="top"
                title="Varios bastidores"
              ></em>
            </div>
          </div>
        </div>
        <div class="firstPart">
          <label class="inputLabel" for="peticionType">Masiva importador</label>
        </div>
        <div class="secondPart">
          <span>
            <input
              id="peticionType"
              type="radio"
              value="importador"
              name="peticionType"
              style="cursor: pointer !important"
              (change)="changePeticionType($event)"
            />
          </span>
          <div class="extraTextContainer">
            <div class="extraText">
              <em
                class="fas fa-info-circle"
                data-toggle="tooltip"
                data-placement="top"
                title="Varios bastidores"
              ></em>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="this.solicitudDatos.value.type == 'individual'">
      <div class="pageTitle">Identifique el vehículo</div>
      <div class="lineGradient"></div>

      <div class="wrapper">
        <div class="firstPart">
          <label for="bastidor" id="bastidor">Número de bastidor</label>
        </div>
        <div class="secondPart">
          <input
            class="inputSearch"
            type="text"
            formControlName="bastidor"
            [attr.disabled]="vehiculoValid ? '' : null"
            toUppercase
          />
          <div class="supIndexRequest">*</div>
          <button
            class="searchButton"
            type="button"
            (click)="validateVehiculo()"
            *ngIf="!vehiculoValid"
          >
            <div class="iconSearch">
              <em
                class="fas fa-check-circle"
                data-toggle="tooltip"
                data-placement="top"
                title="Validar bastidor"
              ></em>
            </div>
          </button>
          <button
            class="searchButton"
            type="button"
            (click)="initFormGroupIndividual()"
            *ngIf="vehiculoValid"
          >
            <div class="iconSearch">
              <em
                class="fas fa-sync-alt"
                data-toggle="tooltip"
                data-placement="top"
                title="Reiniciar validación"
              ></em>
            </div>
          </button>
        </div>
        <div class="firstPart">
          <label id="modelo" for="modelo">Modelo</label>
        </div>
        <div class="secondPart">
          <app-input-selector-with-search
            [list]="lists.modeloList"
            [fields]="['texto']"
            [id]="'Valor'"
            [active]="!vehiculoValid"
            (sendValue)="valueSelectModelo($event)"
            #selectModelo
          ></app-input-selector-with-search>
          <div class="supIndexRequest">*</div>
        </div>
        <div class="firstPart">
          <label id="tipoMotor" for="tipoMotor">Código Motor</label>
        </div>
        <div class="secondPart">
          <app-input-selector-with-search
            [list]="lists.tipoMotorList"
            [fields]="['Valor']"
            [id]="'Valor'"
            [active]="!vehiculoValid"
            (sendValue)="valueSelectTipoMotor($event)"
            #selectTipoMotor
          ></app-input-selector-with-search>
          <div class="supIndexRequest">*</div>
        </div>
        <div class="firstPart">
          <label id="tipoCambio" for="tipoCambio">Tipo Cambio</label>
        </div>
        <div class="secondPart">
          <app-input-selector-with-search
            [list]="lists.tipoCambio"
            [fields]="['Texto']"
            [id]="'Valor'"
            [active]="!vehiculoValid"
            (sendValue)="valueSelectTipoCambio($event)"
            #selectTipoCambio
          ></app-input-selector-with-search>
          <div class="supIndexRequest">*</div>
        </div>
        <div class="firstPart">
          <label for="numPuertas" id="numPuertas">Número Puertas</label>
        </div>
        <div class="secondPart">
          <input
            class="inputSearch"
            type="number"
            formControlName="numPuertas"
            min="0"
            [attr.disabled]="!vehiculoValid ? '' : null"
            (change)="setNumber()"
          />
          <div class="supIndexRequest">*</div>
        </div>
        <div class="firstPart">
          <label id="motivoReedicion" for="motivoReedicion">
            Motivo Reedición
          </label>
        </div>
        <div class="secondPart">
          <app-input-selector-with-search
            [list]="lists.motivoReedicion"
            [fields]="['mrId', 'mrDesc']"
            [id]="'mrId'"
            [active]="!vehiculoValid"
            (sendValue)="valueSelectMotivoReedicion($event)"
            #selectMotivoReedicion
          ></app-input-selector-with-search>
          <div class="supIndexRequest">*</div>
        </div>
        <div class="firstPart">
          <label id="tipoPlaca" for="tipoPlaca">Tipo Placa</label>
        </div>
        <div class="secondPart">
          <app-input-selector-with-search
            [list]="lists.tipoPlaca"
            [fields]="['ValorPlaca', 'TipoPlaca']"
            [id]="'ValorPlaca'"
            [active]="!vehiculoValid"
            (sendValue)="valueSelectTipoPlaca($event)"
            #selectTipoPlaca
          ></app-input-selector-with-search>
          <div class="supIndexRequest">*</div>
        </div>
        <div class="firstPart">
          <label
            id="otroDocumentoAdjuntar"
            *ngIf="this.solicitudDatos.value.type != 'individual'"
            >Fichero carga masiva
          </label>
          <label
            id="otroDocumentoAdjuntar"
            *ngIf="this.solicitudDatos.value.type == 'individual'"
            >Fichero adjunto
          </label>
        </div>
        <div class="secondPart">
          <div
            class="dummyButtonContainerAux"
            style="cursor: pointer !important"
          >
            <div class="dummyButton">
              <em class="fas fa-file-upload"></em>
            </div>
            <div class="dummyFileInputAux" style="min-height: 20px !important">
              <div
                class="dummyFileNameAux adjustText"
                style="max-height: 20px !important"
              >
                {{ file.name }}
              </div>
            </div>
          </div>
          <input
            class="detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
            type="file"
            style="cursor: pointer !important"
            [attr.disabled]="!vehiculoValid ? '' : null"
            (change)="handleFileInput($event)"
          />
          <div class="supIndexRequest">*</div>
        </div>
        <div class="firstPart">
          <label for="observaciones">Observaciones</label>
        </div>
        <div class="secondPart">
          <textarea
            id="observaciones"
            type="textarea"
            formControlName="observaciones"
            maxlength="650"
          ></textarea>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="this.solicitudDatos.value.type == 'homologar'">
      <div class="pageTitle">Paso 1 - Descargue fichero plantilla</div>
      <div class="lineGradient"></div>
      <div class="wrapper">
        <div class="firstPart" style="min-height: 33px">
          <label id="fileHomologador">Plantilla</label>
        </div>
        <div class="secondPart" style="align-items: center">
          <button
            type="button"
            class="buttonDownload reduceSize"
            (click)="onDownload('H')"
          >
            <em class="fas fa-file-download"></em>
          </button>
        </div>
      </div>
      <div class="pageTitle">Paso 2 - Cumplimente fichero plantilla</div>
      <div class="lineGradient"></div>

      <div class="pageTitle">Paso 3 - Adjunte fichero plantilla</div>
      <div class="lineGradient"></div>

      <div class="wrapper">
        <div class="firstPart">
          <label id="otroDocumentoAdjuntar">Fichero carga masiva</label>
        </div>
        <div class="secondPart">
          <div
            class="dummyButtonContainerAux"
            style="cursor: pointer !important"
          >
            <div class="dummyButton">
              <em class="fas fa-file-upload"></em>
            </div>
            <div class="dummyFileInputAux" style="min-height: 20px !important">
              <div
                class="dummyFileNameAux adjustText"
                style="max-height: 20px !important"
              >
                {{ file.name }}
              </div>
            </div>
          </div>
          <input
            #fileHomologador
            class="detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
            type="file"
            style="cursor: pointer !important"
            (change)="handleFileInput($event)"
          />
          <div class="supIndexRequest">*</div>
        </div>
        <div class="firstPart" style="min-height: 33px">
          <label id="facturar">Solamente Facturar</label>
        </div>
        <div class="secondPart" style="align-items: center">
          <label class="mr-1">Sí</label>
          <span>
            <input
              type="radio"
              value="1"
              name="solamenteFacturar"
              style="cursor: pointer !important; margin-top: 6px"
              [checked]="this.solicitudDatos.value.facturar == '1'"
              (change)="setFacturar($event)"
            />
          </span>
          <label class="mr-1 ml-2">No</label>
          <span>
            <input
              type="radio"
              value="0"
              name="solamenteFacturar"
              style="cursor: pointer !important; margin-top: 6px"
              [checked]="this.solicitudDatos.value.facturar == '0'"
              (change)="setFacturar($event)"
            />
          </span>
          <div class="supIndexRequest">*</div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="this.solicitudDatos.value.type == 'importador'">
      <div class="pageTitle">Paso 1 - Descargue fichero plantilla</div>
      <div class="lineGradient"></div>
      <div class="wrapper">
        <div class="firstPart" style="min-height: 33px">
          <label id="fileImportador">Plantilla</label>
        </div>
        <div class="secondPart" style="align-items: center">
          <button
            type="button"
            class="buttonDownload reduceSize"
            (click)="onDownload('I')"
          >
            <em class="fas fa-file-download"></em>
          </button>
        </div>
      </div>

      <div class="pageTitle">Paso 2 - Cumplimente fichero plantilla</div>
      <div class="lineGradient"></div>

      <div class="pageTitle">Paso 3 - Adjunte fichero plantilla</div>
      <div class="lineGradient"></div>
      <div class="wrapper">
        <div class="firstPart">
          <label id="otroDocumentoAdjuntar">Fichero carga masiva</label>
        </div>
        <div class="secondPart">
          <div
            class="dummyButtonContainerAux"
            style="cursor: pointer !important"
          >
            <div class="dummyButton">
              <em class="fas fa-file-upload"></em>
            </div>
            <div class="dummyFileInputAux" style="min-height: 20px !important">
              <div
                class="dummyFileNameAux adjustText"
                style="max-height: 20px !important"
              >
                {{ file.name }}
              </div>
            </div>
          </div>
          <input
            #fileImportador
            class="detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
            type="file"
            style="cursor: pointer !important"
            (change)="handleFileInput($event)"
          />
          <div class="supIndexRequest">*</div>
        </div>
      </div>
    </ng-container>
    <div class="blockOfTextLipsum">
      <p [innerHTML]="requestText"></p>
    </div>
    <div class="wrapper">
      <div class="firstPart" style="text-align: left; background-color: white">
        <button class="formButtonBack" type="button" (click)="goList()">
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
      <div class="secondPart">
        <div>
          <button class="formButtonOk" type="submit">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>

  <swal
    #confirmSwal
    title=""
    text=""
    html=""
    width="36em"
    confirmButtonText="Crear una petición nueva"
    denyButtonText="Volver al buzón"
    icon="success"
    [showCancelButton]="false"
    [focusCancel]="true"
    [showDenyButton]="true"
    [swalOptions]="{
      allowEscapeKey: false,
      allowOutsideClick: false
    }"
    (confirm)="createAnotherRequest()"
    (deny)="goList()"
    customClass="estilo"
  >
  </swal>
</div>
